import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormView, DialogModal } from ".";
import { showDialog } from "../../appRedux/actions/common";
import { clearOfferInfo } from "../../appRedux/actions/offers";

function AddInfo() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));

  useEffect(() => {
    if (!dialog) setOpen(dialog);
  }, [dialog]);

  return (
    <Fragment>
      <button
        className="btn btn-primary"
        onClick={() => {
          dispatch(clearOfferInfo());
          setOpen(true);
          dispatch(showDialog({ title: "Add Offer", size: "lg" }));
        }}
      >
        <i className="fa fa-plus" /> Add Offer
      </button>
      {open && (
        <DialogModal
          bodyView={<FormView isUpdate={false} key="add_offer_form" />}
        />
      )}
    </Fragment>
  );
}

export default AddInfo;
